import React from 'react';

export function OrganicBlob({ className = "" }) {
  return (
    <svg
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill="#8B9D83"
        d="M43.3,-62.3C54.9,-54.3,62.4,-40.2,67.4,-25.2C72.4,-10.2,74.9,5.7,71.8,20.2C68.7,34.7,60,47.8,48.1,56.4C36.2,65,21.1,69.1,5.7,69.8C-9.7,70.5,-25.4,67.8,-38.6,60.3C-51.8,52.8,-62.5,40.5,-67.7,26.2C-72.9,11.9,-72.6,-4.4,-67.8,-18.9C-63,-33.4,-53.7,-46.1,-41.5,-53.8C-29.3,-61.5,-14.7,-64.2,0.4,-64.8C15.5,-65.4,31.7,-70.3,43.3,-62.3Z"
        transform="translate(100 100)"
      />
    </svg>
  );
}

export function OrganicBlob2({ className = "", style }) {
  return (
    <svg
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fill="#8B9D83"
        d="M39.5,-65C51.4,-58.1,61.3,-46.9,67.1,-33.9C72.9,-20.9,74.6,-6.1,71.8,7.3C69,20.7,61.7,32.7,52.2,42.3C42.7,51.9,31,59.1,18.1,63.4C5.2,67.7,-9,69.1,-22.6,66.3C-36.2,63.5,-49.2,56.5,-58.5,46.3C-67.8,36.1,-73.4,22.7,-74.3,8.9C-75.2,-4.9,-71.4,-19.1,-64.1,-31.5C-56.8,-43.9,-46,-54.5,-33.7,-61C-21.4,-67.5,-7.6,-70,5.3,-68.3C18.2,-66.6,27.6,-71.9,39.5,-65Z"
        transform="translate(100 100)"
      />
    </svg>
  );
}

export function OrganicBlob3({ className = "", style }) {
  return (
    <svg
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fill="#8B9D83"
        d="M47.3,-78.6C59.3,-70.2,65.7,-53.5,70.3,-37.7C74.9,-21.9,77.7,-7,76.3,7.3C74.9,21.6,69.3,35.3,60.5,46.2C51.7,57.1,39.7,65.2,26.3,69.8C12.9,74.4,-2,75.5,-16.3,72.8C-30.6,70.1,-44.3,63.6,-54.8,53.4C-65.3,43.2,-72.6,29.3,-74.8,14.6C-77,-0.1,-74.1,-15.6,-67.5,-28.9C-60.9,-42.2,-50.6,-53.3,-38.3,-61.5C-26,-69.7,-13,-75,1.7,-77.8C16.4,-80.6,35.3,-87,47.3,-78.6Z"
        transform="translate(100 100)"
      />
    </svg>
  );
}

export function CirclePattern({ className = "", style }) {
  return (
    <svg
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <circle cx="40" cy="40" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="80" cy="40" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="120" cy="40" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="160" cy="40" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="40" cy="80" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="80" cy="80" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="120" cy="80" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="160" cy="80" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="40" cy="120" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="80" cy="120" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="120" cy="120" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="160" cy="120" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="40" cy="160" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="80" cy="160" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="120" cy="160" r="3" fill="#8B9D83" opacity="0.5" />
      <circle cx="160" cy="160" r="3" fill="#8B9D83" opacity="0.5" />
    </svg>
  );
}
